import axios from 'axios';
import qs from "qs";
import {
    baseApiUrl,
    collect_file,
    fixed_baseApiIpHost,
    fixed_baseApiIpHost_enabled,
    timeout
} from '../../../config/config'
import {constants} from "../../constants";

const _protocol = window.location.protocol; // http:
let _host;
if (fixed_baseApiIpHost_enabled) {
    _host = fixed_baseApiIpHost;
} else {
    _host = window.location.host;   // localhost:81
}
const API_PATH = _protocol + "//" + _host + baseApiUrl;
const FILE_PATH = _protocol + "//" + _host + collect_file;
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
axios.defaults.baseURL = API_PATH;
axios.defaults.timeout = timeout;// 超时时间

export const axiosObj = {

    _axios: axios,

    getFileUrl(fileUri) {
        return fileUri && fileUri != "" ? (FILE_PATH + fileUri) : null;
    },

    /**
     * post请求，参数在拼接在url后面
     * @param url
     * @param params
     * @returns {AxiosPromise}
     */
    post_url: function (url, params) {
        axios.defaults.headers.Authorization = constants.getToken();
        return axios.post(url, qs.stringify(params));
    },

    /**
     * post请求，参数body里
     * @param url
     * @param params
     * @returns {AxiosPromise}
     */
    post_body: function (url, params) {
        axios.defaults.headers.Authorization = constants.getToken();
        return axios.post(url, params);
    },

    /**
     * get请求
     * @param url
     * @param params
     * @returns {AxiosPromise}
     */
    get: function (url, params) {
        axios.defaults.headers.Authorization = constants.getToken();
        return axios.get(url, {params: params});
    },

    /**
     * delete请求
     * @param url
     * @param params
     * @returns {AxiosPromise}
     */
    del: function (url, params) {
        axios.defaults.headers.Authorization = constants.getToken();
        return axios.delete(url, {params: params});
    }
}



// WEBPACK FOOTER //
// ./src/common/base/_axios.js